export type CanvasZoom = number | 'fit';
export type DesktopViewportWidth = 1280 | 1440 | 1600;
export const DESKTOP_VIEWPORT_WIDTHS: readonly DesktopViewportWidth[] = [1280, 1440, 1600];

export const CANVAS_ZOOM_STEPS = [50, 67, 75, 80, 90, 100, 110, 125] as const;

export function availableWorkspaceWidth(
  clientWidth: number,
  paddingLeft: number,
  paddingRight: number,
): number {
  const values = [clientWidth, paddingLeft, paddingRight].map((value) => Number.isFinite(value) ? value : 0);
  // clientWidth already excludes borders and a vertical scrollbar while
  // including padding, so only inline padding is removed here.
  return Math.max(0, values[0] - values[1] - values[2]);
}

export function fitCanvasScale(availableWidth: number, logicalWidth: number): number {
  if (!Number.isFinite(availableWidth) || !Number.isFinite(logicalWidth) || availableWidth <= 0 || logicalWidth <= 0) return 1;
  return Math.min(1, availableWidth / logicalWidth);
}

export function resolvedCanvasScale(zoom: CanvasZoom, availableWidth: number, logicalWidth: number): number {
  return zoom === 'fit' ? fitCanvasScale(availableWidth, logicalWidth) : zoom / 100;
}

export function screenToCanvas(value: number, scale: number): number {
  return value / Math.max(scale, 0.01);
}

export function canvasToScreen(value: number, scale: number): number {
  return value * Math.max(scale, 0.01);
}
